import React from "react";
import AddEntityPopup from "components/Records/NewRecordPages/AddEntityPopup";
import { eventsAPI } from "api/Interactions/EventsAPI";

interface AddEventsPopupProps {
  open: boolean;
  onClose: () => void;
  onSaved?: (newEvents: any) => void;
}

const AddEventsPopup: React.FC<AddEventsPopupProps> = ({ open, onClose, onSaved }) => {
  return (
    <AddEntityPopup
      open={open}
      onClose={onClose}
      title="Add New Event"
      createFunction={eventsAPI.create as (data: Record<string, any>) => Promise<any>}
      fields={[
        { name: "name", label: "Title", required: true },
        { name: "description", label: "Description" },
        { name: "linked_campaign", label: "Campaign", required: true },
      ]}
      onSaved={onSaved}
    />
  );
};

export default AddEventsPopup;
